import { useEffect, useState } from "react";
import Parse from "../api/ApiConfig";

const useParameters = () => {
	const [parameters, setParameters] = useState(null);

	const getParameters = async () => {
		try {
			const query = new Parse.Query("Parameters");
			const response = await query.find();
			const jsonData = response?.map((a) => a?.toJSON());
			setParameters(jsonData);
			// console.log(jsonData);
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		getParameters();
	}, []);

	return parameters;
};

export default useParameters;
